module.exports = window["sheerId"];